import * as SimpleReactValidator from 'simple-react-validator';

export default function validation() {
    return new SimpleReactValidator({
        accepted: {
            message: "The :attribute must be accepted.",
            rule: function (e) {
                return !0 === e
            }
        },
        alpha: {
            message: "The :attribute may only contain letters.",
            rule: function (t) {
                return t.length === 0 ? true : _testRegex(t, /^[A-Z]*$/i)
            }
        },
        alpha_num: {
            message: "The :attribute may only contain letters and numbers.",
            rule: function (t) {

                return t.length === 0 ? true : _testRegex(t, /^[A-Z0-9]*$/i)
            }
        },
        alpha_num_dash: {
            message: "The :attribute may only contain letters, numbers, and dashes.",
            rule: function (t) {
                return t.length === 0 ? true : _testRegex(t, /^[A-Z0-9_-]*$/i)
            }
        },
        card_exp: {
            message: "The :attribute must be a valid expiration date.",
            rule: function (t) {
                return t.length === 0 ? true : _testRegex(t, /^(([0]?[1-9]{1})|([1]{1}[0-2]{1}))\s?\/\s?(\d{2}|\d{4})$/)
            }
        },
        card_num: {
            message: "The :attribute must be a valid credit card number.",
            rule: function (t) {
                return t.length === 0 ? true : _testRegex(t, /^\d{4}\s?\d{4,6}\s?\d{4,5}\s?\d{0,8}$/)
            }
        },
        currency: {
            message: "The :attribute must be a valid currency.",
            rule: function (t) {
                // eslint-disable-next-line
                return t.length === 0 ? true : _testRegex(t, /^\$?(\d{1,3}(\,?\d{3}))*\.?\d{0,2}$/)
            }
        },
        decimal: {
            message: "The :attribute must be a valid decimal.",
            rule: function (t) {
                return t.length === 0 ? true : _testRegex(t, /^-?\d*\.?\d*$/)
            }
        },
        email: {
            message: "The :attribute must be a valid email address.",
            rule: function (t) {
                return t.length === 0 ? true : _testRegex(t, /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)
            }
        },
        gt: {
            message: "The :attribute must be greater than :gt.",
            rule: function (t, r) {
                return !!_testRegex(t, /^\d+.?\d*$/) && parseFloat(t) > parseFloat(r[0])
            },
            messageReplace: function (e, t) {
                return e.replace(":gt", t[0])
            }
        },
        gte: {
            message: "The :attribute must be greater than or equal to :gte.",
            rule: function (t, r) {
                return !!_testRegex(t, /^\d+.?\d*$/) && parseFloat(t) >= parseFloat(r[0])
            },
            messageReplace: function (e, t) {
                return e.replace(":gte", t[0])
            }
        },
        in: {
            message: "The selected :attribute must be :values.",
            rule: function (e, t) {
                return t.indexOf(e) > -1
            },
            messageReplace: function (t, r) {
                return t.replace(":values", _toSentence(r))
            }
        },
        integer: {
            message: "The :attribute must be an integer.",
            rule: function (t) {
                return t.length > 0 ? _testRegex(t, /^\d+$/) : true
            }
        },
        lt: {
            message: "The :attribute must be less than :lt.",
            rule: function (t, r) {
                return !!_testRegex(t, /^\d+.?\d*$/) && parseFloat(t) < parseFloat(r[0])
            },
            messageReplace: function (e, t) {
                return e.replace(":lt", t[0])
            }
        },
        lte: {
            message: "The :attribute must be less than or equal to :lte.",
            rule: function (t, r) {
                return !!_testRegex(t, /^\d+.?\d*$/) && parseFloat(t) <= parseFloat(r[0])
            },
            messageReplace: function (e, t) {
                return e.replace(":lte", t[0])
            }
        },
        max: {
            message: "The :attribute may not be greater than :max characters.",
            rule: function (e, t) {
                return e.length === 0 ? true : e.length <= t[0]
            },
            messageReplace: function (e, t) {
                return e.replace(":max", t[0])
            }
        },
        min: {
            message: "The :attribute must be at least :min characters.",
            rule: function (e, t) {
                return e.length === 0 ? true : e.length >= t[0]
            },
            messageReplace: function (e, t) {
                return e.replace(":min", t[0])
            }
        },
        not_in: {
            message: "The selected :attribute must not be :values.",
            rule: function (e, t) {
                return -1 === t.indexOf(e)
            },
            messageReplace: function (t, r) {
                return t.replace(":values", _toSentence(r))
            }
        },
        numeric: {
            message: "The :attribute must be a number.",
            rule: function (t) {
                return t.length === 0 ? true : _testRegex(t, /^\d+.?\d*$/)
            }
        },
        phone: {
            message: "The :attribute must be a valid phone number.",
            rule: function (t) {
                return t.length > 0 ? _testRegex(t, /(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)/) : true
            }
        },
        required: {
            message: "The :attribute field is required.",
            rule: function (t) {
                return _testRegex(t, /.+/)
            }
        },
        url: {
            message: "The :attribute must be a url.",
            rule: function (t) {
                // eslint-disable-next-line
                return t.length === 0 ? true : _testRegex(t, /^(https?|ftp):\/\/(-\.)?([^\s\/?\.#-]+\.?)+(\/[^\s]*)?$/i)
            }
        },
        underCurDate: {
            message: "The :attribute should not be greater than current date.",
            rule: function (t) {
                // eslint-disable-next-line                
                return t.length === 0 ? true : new Date(t).getTime() <= new Date().getTime()
            }
        },
        paymentOrAdjustment: {
            message: 'Choose Payment / Adjustment Amount', // give a message that will display when there is an error. :attribute will be replaced by the name you supply in calling it.
            rule: function (val, options) { // return true if it is succeeds and false it if fails validation. 
                return ((parseFloat(options[0]) !== 0) || (parseFloat(options[1]) !== 0)) ? true : false;
            }
        },
        amountShouldNotBeLessThanZero: {
            message: 'Amount should not be less than 0', // give a message that will display when there is an error. :attribute will be replaced by the name you supply in calling it.
            rule: function (val, options) { // return true if it is succeeds and false it if fails validation. 
                return ((parseFloat(options[0]) < 0)) ? false : true;
            }
        },
        paymentAmountCheck: {
            message: 'Amount should not greater than Total Due', // give a message that will display when there is an error. :attribute will be replaced by the name you supply in calling it.
            rule: function (val, options) { // return true if it is succeeds and false it if fails validation. 
                return (parseFloat(options[1]) >= parseFloat(options[0])) ? true : false;
            }
        },
        paymentDate: {
            message: 'The :attribute is required', // give a message that will display when there is an error. :attribute will be replaced by the name you supply in calling it.
            rule: function (val, options) { // return true if it is succeeds and false it if fails validation.
                return ((parseFloat(options[0]) !== 0) && (options[1].length === 0)) ? false : true;
            }
        },
        adjustmentDate: {
            message: 'The :attribute is required', // give a message that will display when there is an error. :attribute will be replaced by the name you supply in calling it.
            rule: function (val, options) { // return true if it is succeeds and false it if fails validation. 
                return ((parseFloat(options[0]) !== 0) && (options[1].length === 0)) ? false : true;
            }
        },
        customRequired: {
            message: "The :attribute field is required.",
            rule: function (t) {
                return t !== null && t.toString() !== "" ? true : false
            }
        },
        SSN: {
            message: "The :attribute must be a valid SSN.",
            rule: function (t) {
                // eslint-disable-next-line    
                return t.length > 0 ? _testRegex(t, /^[0-9]{3}\-?[0-9]{2}\-?[0-9]{4}$/) : true
            }
        },
        serviceStartDate: {
            message: 'Servie Start date must be Lesser than Service End date', // give a message that will display when there is an error. :attribute will be replaced by the name you supply in calling it.
            rule: function (val, options) { // return true if it is succeeds and false it if fails validation.
                return options[0].length === 0 ? true : new Date(options[0]) <= new Date(options[1])
            }
        },
        DateOfDelinquency: {
            message: 'Date of Delinquency must be greater than Service End date', // give a message that will display when there is an error. :attribute will be replaced by the name you supply in calling it.
            rule: function (val, options) {
                // return true if it is succeeds and false it if fails validation.
                return options[0].length === 0 || options[0] === "null" || options[0] === null ? true : new Date(options[0]) >= new Date(options[1])
            }
        },
        valueBasedrequired: {
            message: "The :attribute field is required.",
            rule: function (val, options) {
                return options[0] === "false" ? _testRegex(options[1], /.+/) : true
            }
        },


    })
}

function _testRegex(e, t) {
    return null !== e.toString().match(t)
}

function _toSentence(e) {
    return e.slice(0, -2).join(", ") + (e.slice(0, -2).length ? ", " : "") + e.slice(-2).join(e.length > 2 ? ", or " : " or ")
}


// WEBPACK FOOTER //
// ./src/app/components/SimpleReactValidation.js